class ProductSelector extends HTMLElement {
    constructor() {
        super();
        this.product_id = this.getAttribute("product_id");
        this.sideMenuId = `side-menu-selectors`;
        this.setupEventListeners();
        this.initRender();
        
    }

    setupEventListeners() {
        // this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
        // this.input.addEventListener('focus', this.onFocus.bind(this));
        // this.addEventListener('focusout', this.onFocusOut.bind(this));
        // this.addEventListener('keyup', this.onKeyup.bind(this));
        // this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    initRender() {
        this.innerHTML = `...`;
        let productDataScript = document.getElementById(`product_id_${this.product_id}`);
        try {
            this.product_data = JSON.parse(productDataScript.innerHTML);
            console.log("this.product_data", this.product_data);
            this.refreshButton();
        } catch (error) {
            this.innerHTML = ``;
        }
    }

    async refreshButton() {

        this.innerHTML = ``;        
        this.appendChild(this.getCartItemNode(this.product_data, "is_button"));
    }

    getCartItemNode(productData, isButton = false) {
        let cartItem = document.createElement("a");
            cartItem.classList.add("product-selector-item");
            if (productData.id == this.product_data.id) {
                cartItem.classList.add("active");
            } else if (!isButton) {
                cartItem.href = `/products/${productData.handle}`;
            }
            if (isButton) {
                cartItem.classList.add("is-button");
            }
            
            let productImage = document.createElement("div");
                productImage.classList.add("product-image");
                productImage.style.backgroundImage = `URL(${productData.featured_image})`;
                
            let productDetails = document.createElement("div");
                productDetails.classList.add("product-details");
                let productTitle = document.createElement("div");
                    productTitle.classList.add("product-details");
                    productTitle.innerHTML = productData.title;
                let productSize = document.createElement("div");
                    productSize.classList.add("product-details");
            
            let linkWrapper = document.createElement("div");
                linkWrapper.classList.add("link-wrapper");
                linkWrapper.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.35355 8.64645C6.15829 8.45118 5.84171 8.45118 5.64645 8.64645C5.45118 8.84171 5.45118 9.15829 5.64645 9.35355L6.35355 8.64645ZM12 15L11.6464 15.3536L12 15.7071L12.3536 15.3536L12 15ZM18.3536 9.35355C18.5488 9.15829 18.5488 8.84171 18.3536 8.64645C18.1583 8.45118 17.8417 8.45118 17.6464 8.64645L18.3536 9.35355ZM5.64645 9.35355L11.6464 15.3536L12.3536 14.6464L6.35355 8.64645L5.64645 9.35355ZM12.3536 15.3536L18.3536 9.35355L17.6464 8.64645L11.6464 14.6464L12.3536 15.3536Z" fill="#1A1A14"></path></svg>`;

        cartItem.appendChild(productImage);
        cartItem.appendChild(productDetails);
        productDetails.appendChild(productTitle);
        productDetails.appendChild(productSize);
        if (isButton) {
            cartItem.appendChild(linkWrapper);
            this.renderSideMenu();
            cartItem.onclick = () => {
                this.showSideMenu();
            };
        }

        return cartItem;
    }

    showSideMenu() {
        let sideMenu = document.getElementById(this.sideMenuId);
        sideMenu.style.right = `-${sideMenu.clientWidth}px`;
        sideMenu.style.transition = `1s`;
        setTimeout(() => {
            sideMenu.style.right = `0px`;
        }, 10)
    }
    
    hideSideMenu() {
        let sideMenu = document.getElementById(this.sideMenuId);
        sideMenu.style.right = `0px`;
        sideMenu.style.transition = `1s`;
        setTimeout(() => {
            sideMenu.style.right = `-100%`;
        }, 10)
    }

    async renderSideMenu() {
        
        document.getElementById(this.sideMenuId)?.remove();

        let sideMenu = document.createElement("div");
            sideMenu.id = this.sideMenuId;
            sideMenu.classList.add("product-selector-side-menu");
            
            let sideMenuTitleWrapper = document.createElement("div");
                sideMenuTitleWrapper.classList.add("product-selector-side-menu-title-wrapper");
                let sideMenuTitle = document.createElement("div");
                    sideMenuTitle.classList.add("product-selector-side-menu-title");
                    sideMenuTitle.innerHTML = `Elige una opción`;
                
                let sideMenuClose = document.createElement("div");
                    sideMenuClose.classList.add("product-selector-side-menu-close");
                    sideMenuClose.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 5L5 19M5.00001 5L19 19" stroke="#1A1A14" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
                    sideMenuClose.onclick = () => this.hideSideMenu();


            let popupItems = document.createElement("div");

            let collectionResponse = await fetch(`/collections/all?filter.p.product_type=${this.product_data.type}&view=blank`, {method: "GET"});
            let products           = await collectionResponse.json();
            
            products.forEach(product => {
                popupItems.appendChild(this.getCartItemNode(product));
            });

        
            sideMenuTitleWrapper.appendChild(sideMenuTitle);
            sideMenuTitleWrapper.appendChild(sideMenuClose);
            sideMenu.appendChild(sideMenuTitleWrapper);
            sideMenu.appendChild(popupItems);
        document.body.appendChild(sideMenu);
    }
  
}

customElements.define('product-selector', ProductSelector);
  